<div class="d-flex align-items-center modal-header ps-3 pe-3 pt-2 pb-2">
  <h5 class="modal-title">
    <b fileNameDisplay [fileName]="file?.displayName || file?.name"></b>
  </h5>
  <button
    id="login-with-email-close-btn"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.close('')">
  </button>
</div>
<div class="container mb-3 mt-3">
  <!-- TODO: Ignore change to old-mtm-media-player -->
  <mtm-media-player
    [item]="file"
    class="w-100 h-100"
    [mode]="'view'"
    [width]="'100%'"
    [height]="'100%'"
    [autoPlayVideo]="true">
  </mtm-media-player>
</div>
